import { FETCH_COUNTRY } from "../actions";

export const fetchCountry = (countries) => ({
	type: FETCH_COUNTRY,
	countries,
});
